import React from 'react'
import { AreaIcon } from '@/src/renderer/components/icons/AreaIcon'
import { ProjectIcon } from '@/src/renderer/components/common/ProjectIcon'

interface CollapsedProjectBadgeProps {
  projectName: string
  /** Das Projekt-Icon; ohne steht das Standard-Icon. */
  projectIcon?: string | null
  projectIconColor?: string | null
}

/**
 * Inline badge shown right of the task title in the collapsed TaskEntry
 * row, currently only on DormantPage. Carries the parent project's name
 * so paused tasks keep their project context visible without a click.
 *
 * Visuals (from Figma 4185:43049): 2×8 px padding, 8 px radius, 12 px
 * AreaIcon + 12 px / weight 600 / line-height 16 px label. Border + text
 * use the ambient `--space-300` / `--space-700` tokens which auto-swap
 * per lifespace via the `[data-space]` attribute on `<html>` — Personal
 * violet, Work indigo, Home teal.
 */
export const CollapsedProjectBadge: React.FC<CollapsedProjectBadgeProps> = ({
  projectName,
  projectIcon,
  projectIconColor,
}) => (
  <span
    className="task-entry__project-badge"
    data-row-fit="project-badge"
    role="note"
    aria-label={projectName}
  >
    <ProjectIcon
      icon={projectIcon}
      iconColor={projectIconColor}
      size={12}
      className="task-entry__project-badge-icon"
      fallback={<AreaIcon size={12} className="task-entry__project-badge-icon" />}
    />
    <span className="task-entry__project-badge-name">{projectName}</span>
  </span>
)
